document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    // Find menu link with text "Testimonial"
    const menuLinks = document.querySelectorAll('header nav a');
    let testimonialLink = null;

    menuLinks.forEach(link => {
      if (link.textContent.trim().toLowerCase() === "testimonial") {
        testimonialLink = link;
      }
    });

    if (!testimonialLink) return;

    testimonialLink.addEventListener("click", function (e) {
      e.preventDefault();

      // Product page: open reviews tab
      if (window.location.pathname.includes("/products/")) {
        const reviewsTab = document.querySelector('.m-tab-header[data-block-type="reviews"]');
        if (reviewsTab) {
          reviewsTab.click();
          reviewsTab.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        return;
      }

      // Homepage section
      const section = document.querySelector('#loved-by-customers');
      if (section && (window.location.pathname === "/" || window.location.pathname === "/index.html")) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      // Other pages: redirect to homepage and scroll
      const homeUrl = window.location.origin + "/#loved-by-customers";
      window.location.href = homeUrl;
    });
  }, 200);
});
